<template>
  <ul role="list" class="flex flex-col gap-0.5">
    <li v-for="item in items" :key="item.label">
      <span v-if="isActive(item)" class="absolute left-1.5 lg:left-0 w-0.5 h-8 rounded-full bg-accent" />
      <NavItem v-if="!item.children" :item="item" :icons-only="iconsOnly" />
      <Disclosure v-else  v-slot="{ open }" as="div" class="relative" >
        <DisclosureButton
          :class="[
            'group w-full flex gap-3 rounded-md px-2 py-2.5 sm:py-2 text-slate-400 font-medium text-base/6 sm:text-sm/5',
            (isActive(item)) ? 'bg-secondary/5 text-white' : 'hover:bg-secondary/5 text-slate-400',
            { 'px-3': !iconsOnly }
          ]"
        >
          <component :is="item.icon" v-if="item.icon" class="size-5" aria-hidden="true" />
          <span v-else-if="item.iconClass" :class="[item.iconClass, 'size-5']" aria-hidden="true" />

          <span v-if="!iconsOnly">{{ item.label }}</span>
          <span class="ml-auto">
            <span :class="[{'i-heroicons-chevron-down': open, 'i-heroicons-chevron-right': !open }, 'size-4']" aria-hidden="true" />
          </span>
        </DisclosureButton>
        <div v-show="open || isActive(item)" class="overflow-hidden">
          <DisclosurePanel static as="ul" class="mt-1 px-2 border-l border-secondary/5 ml-5">
            <li v-for="child in item.children" :key="child.name">
              <NavItem :item="child" :icons-only="iconsOnly" class="pl-6 font-normal" />
            </li>
          </DisclosurePanel>
        </div>
      </Disclosure>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import NavItem, { NavItemType } from '@/components/NavItem.vue'
import { useRouter } from 'vue-router'

defineProps({
  iconsOnly: {
    type: Boolean,
    default: false
  },
  items: {
    type: Array as PropType<NavItemType[]>,
    required: true
  }
})

const router = useRouter()
const isActive = (item: NavItemType) => {
  const matchedItemPath = item.href == '/' ? false : router.currentRoute.value.path.includes(item.href)
  const matchedItemName = router.currentRoute.value.matched.some(route => route.name === item.name)

  let matchedChildren = false
  if (item.children) {
    matchedChildren = item.children.some(child => router.currentRoute.value.path.includes(child.href))
  }

  return matchedItemPath || matchedItemName || matchedChildren
}
</script>
